import { render, staticRenderFns } from "./StudyLog.vue?vue&type=template&id=20333d4a&scoped=true&"
import script from "./StudyLog.vue?vue&type=script&lang=js&"
export * from "./StudyLog.vue?vue&type=script&lang=js&"
import style0 from "./StudyLog.vue?vue&type=style&index=0&id=20333d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20333d4a",
  null
  
)

export default component.exports